module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_9006.73385219.png";